<div class="footer-wrapper">
  <div class="row justify-content-between">
    <div
      class="col-12 col-md-4 order-2 order-md-1 mt-3 mt-md-0 text-center text-md-left"
    >
      <div class="copyright-wrapper">
        <p>&copy; {{ currentDate.getFullYear() }}. IQ Central Limited</p>
      </div>
    </div>
    <div class="col-12 col-md-8 order-1 order-md-2">
      <div class="footer-links float-md-right">
        <ul class="nav">
          <li class="nav-item px-2">About</li>
          <li class="nav-item px-2">Terms of use</li>
          <li class="nav-item px-2">Privacy policy</li>
        </ul>
      </div>
    </div>
  </div>
</div>
